const combineFunctions = (a, b) => v => b(a(v));
const pipe = function () {
  for (var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++) {
    transformers[_key] = arguments[_key];
  }
  return transformers.reduce(combineFunctions);
};
export { pipe };